import React, { ReactNode } from 'react';
import './index.scss';

function TagItem({
  text,
  onClick,
  children,
}: {
  text?: string;
  onClick?: (tag: string) => void;
  children?: ReactNode;
}) {
  return (
    <div onClick={() => text && onClick?.(text)} className="dbi_tag_card_tag_item">
      {text ? text : children}
    </div>
  );
}

export default TagItem;
